module.exports = __webpack_public_path__ + "static/media/1.5801a753.png";